<template>
  <div class="body-right history-mobile history" v-if="user">
    <div class="title-body-right">
      <h1 class="title-page" @click="backtoUser()">
        <i class="el-icon-arrow-left icon" />{{ user.userName }}
      </h1>

      <div class="group-btn">
        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>

        <el-button class="search-mobile" type="primary" @click="onSubmit">
          {{ $t('user.searchBtn') }}
        </el-button>
      </div>
    </div>

    <el-form
      :inline="true"
      :model="search"
      class="form container-search"
      :class="openSearchForm ? 'visible' : 'hidden'"
      @submit.native.prevent
      @keyup.enter.native="onSubmit()"
    >
      <el-form-item class="form-date date-from" prop="fromDate">
        <el-date-picker
          type="date"
          :placeholder="$t('user.startDate')"
          v-model="search.fromDate"
          style="width: 100%"
          :editable="false"
          :picker-options="pickerBeginDateBefore"
        >
        </el-date-picker>
      </el-form-item>

      <span class="tilde">~</span>

      <el-form-item class="form-date date-to" prop="toDate">
        <el-date-picker
          type="date"
          :placeholder="$t('user.endDate')"
          v-model="search.toDate"
          style="width: 100%"
          :editable="false"
          :picker-options="pickerBeginDateAfter"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <v-select
          class="form-select v-select-search search-history"
          v-model="search.actionType"
          :searchable="false"
          :placeholder="$t('user.actionType')"
          :options="[
            ...[...ESearchHistory.getKeys()].map((key) => ({
              label: key,
              value: ESearchHistory.getValue(key),
            })),
          ]"
          ><template #open-indicator="{ attributes }">
            <img
              v-bind="attributes"
              src="@/assets/images/down-icon.png"
              class="down-icon"
              :class="search.actionType && `selected`"
            /> </template
          ><template #no-options="">
            {{ $t('common.emptyText') }}
          </template></v-select
        >
      </el-form-item>

      <div class="button search-pc history-search">
        <el-form-item>
          <el-button class="search-button" type="primary" @click="onSubmit">
            {{ $t('user.searchBtn') }}
          </el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-row
      class="total-table"
      :class="openSearchForm ? 'total-table-absolute' : ''"
    >
      <el-col :xs="12">
        {{ $t('user.total') }}: {{ userHistory.total }}
      </el-col>
    </el-row>

    <table-list
      :dataColumn="userHistory.data"
      :currentPage="userHistory.currentPage"
    />

    <div class="pagination">
      <base-pagination
        :totalPage="userHistory.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.page"
      >
      </base-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { LIMIT, PAGE } from '@/constants/common';
import { redirectRouter, trimValue, formatDate, formatNumber } from '@/helper';
import * as pageRouter from '@/constants/pageRouter';
const BasePagination = () => import('@/components/BasePagination');

const TableList = () => import('./TableList');
import { ESearchHistory } from '@/enums/user';

export default {
  name: 'HistoryDetail',
  components: {
    BasePagination,
    TableList,
  },
  data() {
    return {
      search: {
        fromDate: undefined,
        toDate: undefined,
        actionType: undefined,
        page: PAGE,
        limit: LIMIT,
      },
      formLabelWidth: '120px',
      openSearchForm: true,
      ESearchHistory,
      pickerBeginDateBefore: {
        disabledDate: (time) => {
          let beginDateVal = this.search.toDate;
          if (beginDateVal) {
            return time.getTime() > beginDateVal;
          }
        },
      },
      pickerBeginDateAfter: {
        disabledDate: (time) => {
          let beginDateVal = this.search.fromDate;
          if (beginDateVal) {
            return time.getTime() < beginDateVal;
          }
        },
      },
    };
  },
  created() {
    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
      actionType: this.$router.currentRoute.query.actionType && {
        label: ESearchHistory.getKey(
          +this.$router.currentRoute.query.actionType
        ),
        value: this.$router.currentRoute.query.actionType,
      },
      limit: LIMIT,
    };

    this.getUserHistory({
      id: this.$route.params.id,
      params: {
        ...this.search,
        actionType: this.search.actionType && this.search.actionType.value,
      },
    });

    this.getUserDetail({ id: this.$route.params.id });
  },
  computed: {
    ...mapGetters('user', ['userHistory']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('category', ['getCategoryList']),
    ...mapActions('user', ['getUserHistory']),
    ...mapActions('user', ['getUserDetail']),
    formatNumber,
    backtoUser() {
      redirectRouter({
        path: pageRouter.USER,
      });
    },
    async onSubmit() {
      this.search = {
        ...trimValue({ ...this.search }),
        page: PAGE,
        limit: LIMIT,
        fromDate: this.search.fromDate
          ? formatDate(this.search.fromDate)
          : undefined,
        toDate: this.search.toDate ? formatDate(this.search.toDate) : undefined,
      };
      await this.getUserHistory({
        id: this.$route.params.id,
        params: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
        },
      });

      redirectRouter({
        path: `/users/${this.$route.params.id}`,
        query: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
          limit: undefined,
        },
      });
    },
    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        actionType: this.$router.currentRoute.query.actionType && {
          label: ESearchHistory.getKey(
            +this.$router.currentRoute.query.actionType
          ),
          value: this.$router.currentRoute.query.actionType,
        },
        page: e.page,
        limit: LIMIT,
      };

      this.getUserHistory({
        id: this.$route.params.id,
        params: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
        },
      });

      redirectRouter({
        path: `/users/${this.$route.params.id}`,
        query: {
          ...this.search,
          actionType: this.search.actionType && this.search.actionType.value,
          page: this.search.page || undefined,
          limit: undefined,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
@import './styles.module.scss';

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  _::-webkit-full-page-media,
  _:future,
  :root,
  .vs__search {
    padding-left: 14px;
  }
}
</style>
